module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTHNzc3p6enZ2dnt7e3l5eXx8fHh4eHp6ent7e3p6ent7e3h4eHp6enl5eUp3tBMAAAAPdFJOUwAJfCLzWf4UqufC20KSNUKQYPYAAADxSURBVDjLY2AYBcQD9lABdCGeYBDJt/oAusSrNWAdbYvRxJnbmiHyuQWoEkLeEDNYpyiiSkQ6QWxlVJmKIs667TqUVZsdiCwRnWEAt2wTki2l25rhbFuXywgn3YRrALpY0yscxjzheRnJWNFtMw6DXSJ+YtpUZMczL3OZpWNeXm6nNcVtD7JDLLx1t3ju6li102VvVNYB5DDYKmjaPdPNc3fTc7lla5A0AD3CWPy0pfVxITCEEFqAGiAhAA4avmXr4GEwOwBJAhiosAiSucqALMF3FSbBWIAiwVCIFj9wCQYMiYs4JDRx6GAwOjCaZ6gLAPuBQOnj/7m0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine/sl_login_ic_ce.png
// module id = SiWz
// module chunks = 1